import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { Popover } from "components";
import { css } from "react-emotion";
import ProfilePopup from "./ProfilePopup";
import LinksPopup from "./LinksPopup";
import { user as userType } from "api/users/types";
import i6 from "assets/images/i6.svg";

const propTypes = {
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  user: userType.isRequired,
};

class Header extends React.Component {
  render() {
    const { open, toggle, user, location } = this.props;

    return (
      <nav className={`nav-toppanel ${open ? "" : closedNav}`}>
        <div className="main-nav">
          <div className="nav-toppanel--left">
            <div className="nav-toppanel--slide-left-btn">
              <button className="panel-open" type="button" onClick={toggle} />
            </div>
            <div className="nav-toppanel--icons-wrapper">
              <Popover orientation="right" offsetTop={90} location={location} fixed={true}>
                {{
                  btn: open => (
                    <div className="nav-toppanel--single-icon-wrapper" onClick={open}>
                      <div className="icon-box">
                        <img src={i6} alt="" />
                      </div>
                    </div>
                  ),
                  window: <LinksPopup />,
                }}
              </Popover>
            </div>

            <div id="top-panel-portal" />
          </div>
          <div className="nav-toppanel--right">
            <div className="nav-toppanel--user-profile">
              <Popover orientation="left" offsetTop={90} location={location} fixed={true}>
                {{
                  btn: open => (
                    <div className="avatar-outer--sm-box a-bg-7">
                      <div className="avatar-inner-sm-box" onClick={open}>
                        {user.initials}
                      </div>
                    </div>
                  ),
                  window: <ProfilePopup user={user} />,
                }}
              </Popover>
            </div>
          </div>
        </div>
        <div id="subnav-portal" className={subnavPortal} />
      </nav>
    );
  }
}

Header.propTypes = propTypes;

const mapState = state => ({
  user: state.auth.user,
});

export default withRouter(connect(mapState)(Header));

const closedNav = css`
  margin-left: 0;
  width: calc(100% - 20px);
`;

const subnavPortal = css`
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/partialComponents/panelWrapper/subcomponents/Header.jsx